<!--
 * @Description: 车型识别一体机
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 16:11:08
 -->
<template>
  <div class="VehicleIdentification">
    <div class="line1">
      <Line1 />
    </div>
    <div class="line2">
      <Line2 />
    </div>
    <div class="line3">
      <Line3 />
    </div>
    <div class="line4">
      <div class="line4-left">
        <Line4Left />
      </div>
      <div class="line4-right">
        <Line4Right />
      </div>
    </div>
  </div>
</template>

<script>
import Line1 from './components/line1'
import Line2 from './components/line2'
import Line3 from './components/line3'
import Line4Left from './components/line4Left'
import Line4Right from './components/line4Right'
export default {
  name: 'VehicleIdentification',
  components: {
    Line1,
    Line2,
    Line3,
    Line4Left,
    Line4Right,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .VehicleIdentification {
    width: 100%;
    height: 100%;
    .line1 {
      width: 100%;
      height: 20%;
    }
    .line2 {
      width: 100%;
      height: 40%;
    }
    .line3 {
      width: 100%;
      height: 15%;
    }
    .line4 {
      width: 100%;
      height: 25%;
      >div {
        display: inline-block;
      }
      .line4-left {
        width: 50%;
        height: 100%;
      }
      .line4-right {
        width: 50%;
        height: 100%;
      }
    }
  }
</style>
